

<ng-container *ngIf="user">

  <ng-container *ngIf="refresh">
    <p-avatar *ngIf="imgUrls && !imageLoadFailed" [image]="(imgUrls! | imageUrl:ImageSize._64x64:cacheImg) ?? ''" (onImageError)="imageLoadFailed = true" shape="circle" [size]="size"></p-avatar>
    <p-avatar *ngIf="!imgUrls || imageLoadFailed" [label]="user.orgUsers | userInitials:selectedOrgService.selectedOrgId$.getValue()" shape="circle" [size]="size"></p-avatar>
  </ng-container>




  <ng-container *ngIf="badge">

    <ng-container *ngIf="!badgeValue">
      <div pBadge [severity]="badgeSeverity">
      </div>
    </ng-container>

    <ng-container *ngIf="badgeValue">

      <div pBadge [value]="badgeValue" [severity]="badgeSeverity">
      </div>

    </ng-container>

  </ng-container>

</ng-container>
